"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.withUser = withUser;
var _react = _interopRequireWildcard(require("react"));
var _Services = require("./Services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-underscore-dangle */
function withUser(Wrapped) {
  let appearWhileLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _Services.withService)('auth')(function UserComponent(props) {
    const {
      service: auth
    } = props;
    const [user, setUser] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(false);
    const onLogout = (0, _react.useCallback)(() => {
      setUser(false);
      setLoading(false);
      localStorage.clear();
    });
    const onChange = (0, _react.useCallback)(user => {
      if (user.authenticated === false) {
        setUser(false);
        return;
      }
      setUser(_objectSpread({}, user));
    });
    (0, _react.useEffect)(() => {
      auth.user().then(data => {
        setUser(data);
        setLoading(false);
      }).catch(err => {
        setUser(false);
        setLoading(false);
        setError(err);
      });
      auth.emitter.on('logout', onLogout);
      auth.emitter.on('auth', onChange);
      return () => {
        auth.emitter.off('logout', onLogout);
        auth.emitter.off('auth', onChange);
      };
    }, []);
    return loading && !appearWhileLoading ? null : /*#__PURE__*/_react.default.createElement(Wrapped, _extends({}, props, {
      auth: auth,
      user: user,
      userLoading: loading,
      userError: error
    }));
  });
}
var _default = exports.default = withUser;
//# sourceMappingURL=Auth.js.map